import React, { useState, useEffect } from "react";
import "./Academics.css";
import prePrimaryImg from "../assets/image9.JPG";
import PrimaryImg from "../assets/primary1.png";
import HighImg from "../assets/high1.png";

import AOS from "aos";
import "aos/dist/aos.css";

// ICONS
import {
  FaPaintBrush,
  FaBookOpen,
  FaCalculator,
  FaPenFancy
} from "react-icons/fa";

import {
  GiBrain,
  GiSoundWaves
} from "react-icons/gi";

export default function Academics() {
  const [activeTab, setActiveTab] = useState("pre");
  const [activePrimary, setActivePrimary] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);

  useEffect(() => {
    AOS.refresh();
  }, []);
  useEffect(() => {
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 1024);
  };

  window.addEventListener("resize", handleResize);
  return () => window.removeEventListener("resize", handleResize);
}, []);

  // Re-refresh AOS when tab changes so newly rendered elements animate
  useEffect(() => {
    AOS.refresh();
  }, [activeTab]);

  const renderContent = () => {
    switch (activeTab) {

      /* ===================== PRE PRIMARY ===================== */
      case "pre":
        return (
          <>
            {/* ===================== TOP SECTION ===================== */}
            <div className="pre-full-section">

              <div
                className="pre-img-wrap"
                // data-aos="fade-right"
                data-aos-duration="900"
              >
                <img src={prePrimaryImg} alt="Pre Primary" />
              </div>

              <div
                className="pre-text-wrap"
                data-aos="fade-left"
                data-aos-duration="900"
                data-aos-delay="100"
              >
                <h2 data-aos="fade-down" data-aos-delay="200">Pre-Primary Education</h2>
                <h4
                  className="pre-sub"
                  data-aos="fade-down"
                  data-aos-delay="250"
                >
                  (PG, PP1, PP2 & Grade 1)
                </h4>

                <p data-aos="fade-up" data-aos-delay="300">
                  At Lotus Lap Public School, our pre-primary program is thoughtfully
                  designed to nurture young learners during their most important
                  developmental years. We focus on building strong cognitive, motor,
                  and emotional foundations through joyful learning experiences.
                </p>

                <p data-aos="fade-up" data-aos-delay="350">
                  Our environment is safe, caring, and stimulating helping children feel
                  confident to explore, express, and grow. Through play based learning,
                  we encourage curiosity, creativity, and early independence.
                </p>

                <p data-aos="fade-up" data-aos-delay="400">
                  We aim to develop happy, confident learners by strengthening
                  communication skills, early literacy, numeracy, and teamwork
                  preparing them for both school and life.
                </p>

                <ul data-aos="fade-up" data-aos-delay="450">
                  <li>Play based & experiential learning</li>
                  <li>Communication & language development</li>
                  <li>Early reading & writing skills</li>
                  <li>Numbers & basic concepts</li>
                  <li>Social & emotional growth</li>
                  <li>Creativity & imagination building</li>
                  <li>Safe & nurturing environment</li>
                </ul>
              </div>
            </div>

            {/* ===================== ACTIVITIES CARDS ===================== */}
            <div className="pre-activities-full">

              <div className="pre-activities-grid">

                <div
                  className="activity-card"
                  data-aos="zoom-in"
                  data-aos-delay="0"
                >
                  <GiBrain className="activity-icon" />
                  <h3>Sensorial Activities</h3>
                  <p>
                    Engaging activities that stimulate the five senses touch, sight, sound,
                    taste, and smell that help children explore their surroundings while developing
                    the ability to recognize patterns, distinguish sizes, and identify colors
                    with confidence.
                  </p>
                </div>

                <div
                  className="activity-card"
                  data-aos="zoom-in"
                  data-aos-delay="100"
                >
                  <FaPaintBrush className="activity-icon" />
                  <h3>Art</h3>
                  <p>
                    Through painting, drawing, crafting, and hands-on art experiences, children
                    express their imagination freely while enhancing their creativity, fine
                    motor skills, and artistic awareness.
                  </p>
                </div>

                <div
                  className="activity-card"
                  data-aos="zoom-in"
                  data-aos-delay="200"
                >
                  <GiSoundWaves className="activity-icon" />
                  <h3>Language</h3>
                  <p>
                    Early language development is encouraged through fun activities that build
                    listening, sound recognition, and sequencing skills, laying a strong
                    foundation for phonics and effective communication.
                  </p>
                </div>

                <div
                  className="activity-card"
                  data-aos="zoom-in"
                  data-aos-delay="300"
                >
                  <FaPenFancy className="activity-icon" />
                  <h3>Handwriting</h3>
                  <p>
                    Children are introduced to writing through engaging methods that combine
                    play, visuals, and guided practice, helping them gradually develop neatness,
                    confidence, and control in their writing.
                  </p>
                </div>

                <div
                  className="activity-card"
                  data-aos="zoom-in"
                  data-aos-delay="400"
                >
                  <FaBookOpen className="activity-icon" />
                  <h3>Reading</h3>
                  <p>
                    A love for reading is nurtured through phonics based learning, storytelling,
                    and visually engaging books that inspire curiosity and build early literacy
                    skills in an enjoyable way.
                  </p>
                </div>

                <div
                  className="activity-card"
                  data-aos="zoom-in"
                  data-aos-delay="500"
                >
                  <FaCalculator className="activity-icon" />
                  <h3>Math</h3>
                  <p>
                    Basic mathematical concepts are introduced through interactive activities
                    that involve counting, number recognition, and simple operations, helping
                    children develop logical thinking in a fun and practical way.
                  </p>
                </div>

              </div>
            </div>
          </>
        );

      /* ===================== PRIMARY ===================== */
      case "primary":
        const primaryData = [
          {
            title: "Experiential Learning Approach",
            desc: "We believe that true understanding comes from experience. Our teaching methods encourage students to actively participate in learning through practical activities, real life connections, and hands-on exploration. This approach not only strengthens conceptual clarity but also builds confidence in applying knowledge beyond the classroom."
          },
          {
            title: "All-Round Development",
            desc: "Education goes beyond academics. We focus on nurturing every aspect of a child's growth intellectual, physical, social, and emotional. Through a supportive and engaging environment, students develop essential life skills, positive values, and a well rounded personality."
          },
          {
            title: "Life-Ready Individuals",
            desc: "Our goal is to prepare students for life, not just exams. We help them develop physical fitness, mental awareness, and emotional balance so they can face challenges with confidence, resilience, and a positive mindset in every stage of life."
          },
          {
            title: "Balanced Learning Experience",
            desc: "A healthy mix of academics and co-curricular activities allows students to explore their passions and talents. Whether it's sports, arts, or creative pursuits, we provide opportunities that help shape individuality and build self expression."
          },
          {
            title: "Child Centered Environment",
            desc: "Every child learns differently, and we celebrate that uniqueness. Our classrooms are designed to be inclusive, engaging, and student focused, encouraging curiosity, independent thinking, and active participation in the learning process."
          },
          {
            title: "Skill-Based Education",
            desc: "We emphasize practical skills alongside academic knowledge. Through activity based learning and meaningful assessments, students develop critical thinking, creativity, problem-solving abilities, and the confidence to apply their skills in real world situations."
          }
        ];

        return (
          <div className="primary-wrapper">

            {/* TOP PART */}
            <div className="primary-full-section">

              {/* LEFT */}
              <div
                className="primary-left"
                data-aos="fade-right"
                data-aos-duration="900"
              >
                {primaryData.map((item, index) => (
                  <div
                    key={index}
                    className={`primary-card ${activePrimary === index ? "active" : ""}`}
                   onMouseEnter={() => {
  if (!isMobile) setActivePrimary(index);
}}
onClick={() => {
  if (isMobile) setActivePrimary(index);
}}
                    data-aos="fade-right"
                    // data-aos-delay={index * 80}
                  >
                    <h3>{item.title}</h3>

                    <p className="mobile-desc">
                      {activePrimary === index && item.desc}
                    </p>
                  </div>
                ))}
              </div>

              {/* RIGHT */}
              <div
                className="primary-right"
                data-aos="fade-left"
                data-aos-duration="900"
                data-aos-delay="200"
              >
                <h2 data-aos="fade-down" data-aos-delay="300">Primary</h2>
                <h4 data-aos="fade-down" data-aos-delay="350">(Grades 1 – 5)</h4>

                <p data-aos="fade-up" data-aos-delay="400">
                  {primaryData[activePrimary].desc}
                </p>
              </div>

            </div>

            {/* BELOW SECTION */}
            <div className="primary-bottom">

              {/* LEFT TEXT */}
              <div
                className="primary-bottom-text"
                data-aos="fade-right"
                data-aos-duration="900"
              >
                <h3 data-aos="fade-down" data-aos-delay="100">
                  Curriculum & Learning Structure
                </h3>

                <p data-aos="fade-up" data-aos-delay="150">
                  At Lotus Lap Public School, the primary curriculum is carefully
                  designed to build strong academic foundations while nurturing curiosity,
                  confidence, and a love for learning.
                </p>

                <p data-aos="fade-up" data-aos-delay="200">
                  <strong>Grades 1 & 2:</strong> English, Mathematics, Environmental Studies,
                  Telugu, and Hindi.
                  <br />
                  <strong>Grades 3 to 5:</strong> English, Mathematics, Science, Social Studies,
                  Telugu, and Hindi.
                </p>

                <ul data-aos="fade-up" data-aos-delay="250">
                  <li>
                    Students are encouraged to participate in national-level competitive
                    exams such as Olympiads (IMO, NSO, IEO) to enhance their academic exposure.
                  </li>
                  <li>
                    Abacus training strengthens concentration, improves memory, and develops
                    logical thinking skills from an early age.
                  </li>
                  <li>
                    Technology integrated learning makes classrooms more interactive and
                    helps students engage deeply with modern learning tools.
                  </li>
                </ul>
              </div>

              {/* RIGHT IMAGE */}
              <div
                className="primary-bottom-img"
                data-aos="fade-left"
                data-aos-duration="900"
                data-aos-delay="150"
              >
                <img src={PrimaryImg} alt="Primary Section" />
              </div>

            </div>

          </div>
        );

      /* ===================== HIGH SCHOOL ===================== */
      case "high":
        return (
          <div className="high-wrapper">

            {/* TITLE CENTER */}
            <h2
              className="high-title"
              data-aos="fade-down"
              data-aos-duration="700"
            >
              High School
            </h2>
            <h4
              className="high-sub"
              data-aos="fade-down"
              data-aos-duration="700"
              data-aos-delay="100"
            >
              (Grades 6 - 10)
            </h4>

            {/* CONTENT SECTION */}
            <div className="high-content-section">

              {/* LEFT IMAGE */}
              <div
                className="high-img"
                data-aos="fade-right"
                data-aos-duration="900"
              >
                <img src={HighImg} alt="High School" />
              </div>

              {/* RIGHT TEXT */}
              <div
                className="high-text"
                data-aos="fade-left"
                data-aos-duration="900"
                data-aos-delay="100"
              >
                <p data-aos="fade-up" data-aos-delay="200">
                  At this stage, students are guided to grow not only academically but
                  also intellectually and emotionally. Our high school program is
                  thoughtfully structured to help learners connect their knowledge with
                  real life understanding, encouraging deeper thinking and meaningful learning.
                </p>

                <p data-aos="fade-up" data-aos-delay="280">
                  We create a balanced environment where academics, creative expression,
                  and practical experiences come together. This helps students explore
                  their abilities, refine their interests, and develop a strong sense of
                  individuality and purpose.
                </p>

                <p data-aos="fade-up" data-aos-delay="360">
                  As students progress, they naturally develop curiosity and the ability
                  to analyze, question, and reflect. We support them in becoming independent
                  thinkers who are confident in their ideas and capable of making thoughtful
                  decisions for their future.
                </p>

                <ul data-aos="fade-up" data-aos-delay="440">
                  <li>Strong focus on analytical and critical thinking</li>
                  <li>Integration of academics with real world experiences</li>
                  <li>Encouragement of creativity and self expression</li>
                  <li>Development of confidence and independent learning</li>
                  <li>Preparation for higher education and future goals</li>
                </ul>
              </div>

            </div>

            {/* ===================== HIGH SCHOOL FEATURES ===================== */}
            <div className="high-cards-section">

              <div className="high-cards-grid">

                <div
                  className="high-card"
                  data-aos="flip-left"
                  data-aos-duration="700"
                  data-aos-delay="0"
                >
                  <h3>Smart Digital Classrooms</h3>
                  <p>
                    Our classrooms are equipped with advanced digital tools that bring
                    lessons to life through visual and interactive content, making
                    learning more engaging and enjoyable for students.
                  </p>
                </div>

                <div
                  className="high-card"
                  data-aos="flip-left"
                  data-aos-duration="700"
                  data-aos-delay="100"
                >
                  <h3>Beyond Academics</h3>
                  <p>
                    Along with academics, students actively participate in yoga, chess,
                    dance, Vedic math, and martial arts, ensuring a well rounded
                    development of both mind and body.
                  </p>
                </div>

                <div
                  className="high-card"
                  data-aos="flip-left"
                  data-aos-duration="700"
                  data-aos-delay="200"
                >
                  <h3>Parent Partnership</h3>
                  <p>
                    Regular orientation programs create a strong connection between
                    parents and the school, allowing open discussions about student
                    progress and continuous improvement.
                  </p>
                </div>

                <div
                  className="high-card"
                  data-aos="flip-left"
                  data-aos-duration="700"
                  data-aos-delay="300"
                >
                  <h3>Sports & Physical Fitness</h3>
                  <p>
                    Physical education is given equal importance, with structured
                    activities and interschool competitions that build confidence,
                    teamwork, and discipline.
                  </p>
                </div>

                <div
                  className="high-card"
                  data-aos="flip-left"
                  data-aos-duration="700"
                  data-aos-delay="400"
                >
                  <h3>Structured Learning Approach</h3>
                  <p>
                    Teaching follows a well defined academic framework aligned with
                    modern evaluation systems, ensuring continuous learning and
                    consistent progress.
                  </p>
                </div>

                <div
                  className="high-card"
                  data-aos="flip-left"
                  data-aos-duration="700"
                  data-aos-delay="500"
                >
                  <h3>Interactive Smart Learning</h3>
                  <p>
                    Smart class technology enhances understanding by improving
                    listening, reading, and comprehension skills through interactive
                    and student friendly learning experiences.
                  </p>
                </div>

              </div>

            </div>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div className="academics-page">
      <section className="academics-section">
        <div className="academics-content">

          <h1 data-aos="fade-down" data-aos-duration="800">Academics</h1>

          <p
            className="academics-quote"
            data-aos="fade-up"
            data-aos-delay="100"
            data-aos-duration="800"
          >
            "Education is not the filling of a pail, but the lighting of a fire."
          </p>

          <p
            className="academics-text"
            data-aos="fade-up"
            data-aos-delay="200"
            data-aos-duration="800"
          >
            At <span>Lotus Lap Public School</span>, academics are designed to
            inspire curiosity and ignite a passion for learning. We go beyond
            conventional teaching by creating an environment where knowledge is
            explored, questioned, and understood deeply.
          </p>

          <p
            className="academics-text"
            data-aos="fade-up"
            data-aos-delay="300"
            data-aos-duration="800"
          >
            Our approach blends strong fundamentals with modern learning
            techniques, empowering students to think critically, act confidently,
            and grow into lifelong learners prepared for the future.
          </p>

          <div
            className="tabs-container"
            data-aos="fade-up"
            data-aos-delay="400"
            data-aos-duration="700"
          >
            <div className="tabs">
              <button
                className={activeTab === "pre" ? "active" : ""}
                onClick={() => setActiveTab("pre")}
              >
                Pre-Primary
              </button>

              <button
                className={activeTab === "primary" ? "active" : ""}
                onClick={() => setActiveTab("primary")}
              >
                Primary
              </button>

              <button
                className={activeTab === "high" ? "active" : ""}
                onClick={() => setActiveTab("high")}
              >
                High School
              </button>
            </div>

            <div className="tab-content">
              {renderContent()}
            </div>
          </div>

          {/* ===================== CURRICULUM SECTION ===================== */}
          <div className="curriculum-section">

            <h2
              className="curriculum-title"
              data-aos="fade-down"
              data-aos-duration="700"
            >
              Our Curriculum
            </h2>
            <p
              className="curriculum-sub"
              data-aos="fade-up"
              data-aos-delay="100"
              data-aos-duration="700"
            >
              A balanced academic structure designed to build strong foundations and future ready learners.
            </p>

            <div className="curriculum-grid">

              {/* PRIMARY */}
              <div
                className="curriculum-card"
                data-aos="fade-right"
                data-aos-duration="800"
                data-aos-delay="150"
              >
                <h3>Primary School (Grades 1 - 5)</h3>
                <p>
                  We follow an <strong>Integrated Curriculum</strong> that combines the strengths
                  of both CBSE and ICSE frameworks. This approach ensures a strong conceptual
                  foundation while encouraging analytical thinking, creativity, and practical understanding.
                </p>

                <ul>
                  <li>Concept based learning approach</li>
                  <li>Balanced academic depth & application</li>
                  <li>Focus on language, numeracy & reasoning</li>
                </ul>
              </div>

              {/* HIGH SCHOOL */}
              <div
                className="curriculum-card"
                data-aos="fade-left"
                data-aos-duration="800"
                data-aos-delay="250"
              >
                <h3>High School (Grades 6 - 10)</h3>
                <p>
                  For higher classes, we follow the <strong>State Syllabus (SSC)</strong>,
                  providing students with structured academic preparation aligned with
                  board requirements while maintaining strong conceptual clarity.
                </p>

                <ul>
                  <li>Aligned with SSC board standards</li>
                  <li>Strong exam preparation strategy</li>
                  <li>Focus on subject mastery & performance</li>
                </ul>
              </div>

            </div>
          </div>

          {/* ===================== ASSESSMENT SECTION ===================== */}
          <div className="assessment-section">

            <h2
              className="assessment-title"
              data-aos="fade-down"
              data-aos-duration="700"
            >
              Assessment Approach
            </h2>
            <p
              className="assessment-sub"
              data-aos="fade-up"
              data-aos-delay="100"
              data-aos-duration="700"
            >
              A continuous and structured evaluation system to track student growth and achievement.
            </p>

            <div className="assessment-flow">

              {/* LEFT SIDE */}
              <div
                className="assessment-block"
                data-aos="fade-right"
                data-aos-duration="900"
                data-aos-delay="150"
              >
                <h3>Formative Assessment (FA)</h3>
                <h4>(Classes I - IV)</h4>

                <p>
                  Formative Assessment focuses on continuous, in-process evaluation of
                  student learning during lessons and concepts. It helps teachers
                  understand student comprehension, identify learning needs, and guide
                  improvement in real time.
                </p>

                <p>
                  This approach is based on <strong>success criteria</strong> and
                  <strong> judgement statements</strong>, ensuring that every student's
                  progress is monitored effectively while learning is still happening.
                </p>
              </div>

              {/* CENTER LINE */}
              <div
                className="assessment-line"
                data-aos="zoom-in"
                data-aos-duration="600"
                data-aos-delay="300"
              ></div>

              {/* RIGHT SIDE */}
              <div
                className="assessment-block"
                data-aos="fade-left"
                data-aos-duration="900"
                data-aos-delay="150"
              >
                <h3>Summative Assessment (SA)</h3>
                <h4>(Term I - II)</h4>

                <p>
                  Summative Assessment is conducted at the end of an instructional unit
                  to evaluate what students have learned. It measures overall academic
                  achievement and understanding after the completion of teaching.
                </p>

                <p>
                  The goal is to assess student performance, track outcomes, and ensure
                  readiness for the next stage of learning with clarity and confidence.
                </p>
              </div>

            </div>
          </div>

        </div>
      </section>
    </div>
  );
}